import { useQuery } from '@tanstack/react-query';

import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { QUICKBOOKS_BASE_URL } from '.';

import { RemoteOptionsResponse } from '../types';

const url = `${QUICKBOOKS_BASE_URL}/:fileId/getTransactionFields`;

export const getTreatmentOptions = (fileId: number): Promise<RemoteOptionsResponse> => {
  return axios.get(generateRoutePath(url, { fileId }));
};

export const treatmentOptionsKeys = {
  list: ['treatmentOptions'] as const,
  detail: (fileId: number) => [INBOX_API_KEY, ...treatmentOptionsKeys.list, fileId] as const,
};

type QueryFnType = typeof getTreatmentOptions;

type useTreatmentOptionsOptions = {
  fileId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useTreatmentOptions = ({ fileId, config }: useTreatmentOptionsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...treatmentOptionsKeys.list, fileId],
    queryFn: () => getTreatmentOptions(fileId),
    staleTime: Infinity,
    ...config,
  });
};
